import { useEffect } from "react";
import { Routes, Route, useNavigationType, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Details from './pages/Details';
import DashBoard from "./pages/DashBoard";
import NewRecipeMachine from "./pages/NewRecipeMachine";
import MachineGuideVideos from "./pages/MachineGuideVideos";
import MachineReports from "./pages/MachineReports";
import PaginationTable from './components/smallMedia/Ingredientsm';
import "./App.css";
import Unauthorized from "./pages/Unauthorized";
function App() {
  const action = useNavigationType();
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    if (action !== "POP") {
      window.scrollTo(0, 0);
    }
  }, [action, pathname]);

  useEffect(() => {
    let title = "";
    let metaDescription = "";

    switch (pathname) {
      case "/":
        title = "Home";
        metaDescription = "Description for Home Page";
        break;
      case "/details":
        title = "Details";
        metaDescription = "Description for Details Page";
        break;
      // Add more cases as needed
      default:
        title = "Dashboard";
        metaDescription = "Dashboard Description";
    }

    if (title) {
      document.title = title;
    }

    if (metaDescription) {
      const metaDescriptionTag = document.querySelector('head > meta[name="description"]');
      if (metaDescriptionTag) {
        metaDescriptionTag.content = metaDescription;
      }
    }
  }, [pathname]);

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/details" element={<Details />} />
      <Route path="/DashBoard" element={<DashBoard />} />
      <Route path="/ingredients" element={<PaginationTable />} />
      <Route path="/machine-recipe" element={<NewRecipeMachine />} />
      <Route path="/macGuideVideos" element={<MachineGuideVideos />} />
      <Route path="/macReports" element={<MachineReports />} />
      <Route path="/unauthorized" element={<Unauthorized />} />
    </Routes>
  );
}

export default App;
